<template>
  <CollapsibleCard :editable="false">
    <template v-slot:header> Meddelanden </template>

    <template v-slot:info> {{ messages.length }} meddelanden</template>

    <template v-slot:view>
      <ApplicationMessagesView :messages="messages" />
    </template>

  </CollapsibleCard>
</template>

<script>
import {mapGetters} from 'vuex'
import get from 'lodash/get'
import CollapsibleCard from '@/components/common/CollapsibleCard'
import ApplicationMessagesView from './ApplicationMessagesView.vue'

export default {
  name: 'ApplicationMessages',

  components: {
    CollapsibleCard,
    ApplicationMessagesView
  },

  computed: {
    ...mapGetters('application', ['selectedApplication', 'isCompanyApplication']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole']),

    messages() {
      return get(this, 'selectedApplication.notifications', []).slice()
        .reverse()
    }
  }
}
</script>

<style lang="scss">
</style>